import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { objectMessageDirectionPropType } from './object-message-direction-prop-type'
import { objectMessageCategoryPropType } from './object-message-category-prop-type'

export const objectMessagePropType = PropTypes.shape({
    direction: objectMessageDirectionPropType.isRequired, // 'messageFlag' column in DB is not null
    messageCategory: objectMessageCategoryPropType,
    messageId: idPropType.isRequired,
    messageParams: PropTypes.objectOf(PropTypes.string),
    messageTextTemplate: PropTypes.string,
    messageTime: iso8601PropType,
    messageType: PropTypes.string,
    objectId: idPropType.isRequired,
    sentUserId: idPropType
})
